/* eslint-disable react/button-has-type */
// POS  dashboard component
import React, { useState } from 'react';

function PosDashboard() {
  const posData = [
    {
      id: 1, item: 'Burger', price: 150, quantity: 2, total: 300,
    },
    {
      id: 2, item: 'Pizza', price: 200, quantity: 1, total: 200,
    },
    {
      id: 3, item: 'Coke', price: 50, quantity: 3, total: 150,
    },
  ];

  const [activeOrders] = useState([
    {
      id: 1, table: 'Table 2', items: ['Burger', 'Fries'], status: 'preparing',
    },
    {
      id: 2, table: 'Table 5', items: ['Pizza', 'Salad'], status: 'ready',
    },
  ]);

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-2xl font-semibold mb-4">POS Dashboard</h2>

      {/* POS Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white p-4 shadow rounded-xl border">
          <p className="text-gray-500 text-sm">Total Sales</p>
          <p className="text-2xl font-bold text-green-600">৳650</p>
        </div>
        <div className="bg-white p-4 shadow rounded-xl border">
          <p className="text-gray-500 text-sm">Total Transactions</p>
          <p className="text-2xl font-bold text-blue-600">3</p>
        </div>
        <div className="bg-white p-4 shadow rounded-xl border">
          <p className="text-gray-500 text-sm">Pending Orders</p>
          <p className="text-2xl font-bold text-yellow-600">1</p>
        </div>
      </div>

      {/* POS Transactions Table */}
      <div className="bg-white shadow rounded-xl overflow-auto border">
        <h3 className="text-xl font-semibold p-4 border-b">Recent Transactions</h3>
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="text-left px-4 py-2">Item</th>
              <th className="text-left px-4 py-2">Price</th>
              <th className="text-left px-4 py-2">Quantity</th>
              <th className="text-left px-4 py-2">Total</th>
            </tr>
          </thead>
          <tbody>
            {posData.map((transaction) => (
              <tr key={transaction.id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-2">{transaction.item}</td>
                <td className="px-4 py-2">
                  ৳
                  {transaction.price}
                </td>
                <td className="px-4 py-2">{transaction.quantity}</td>
                <td className="px-4 py-2">
                  ৳
                  {transaction.total}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="bg-white p-4 shadow rounded-xl border">
        <p className="text-gray-500 text-sm">Active Tables</p>
        <p className="text-2xl font-bold text-purple-600">5</p>
      </div>
      {/* Add kitchen orders section */}
      <div className="bg-white shadow rounded-xl overflow-auto border mt-6">
        <h3 className="text-xl font-semibold p-4 border-b">Kitchen Orders</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
          {activeOrders.map((order) => (
            <div
              key={order.id}
              className={`border rounded-lg p-3 ${
                order.status === 'ready' ? 'bg-green-50' : 'bg-yellow-50'
              }`}
            >
              <div className="flex justify-between">
                <span className="font-bold">{order.table}</span>
                <span className="text-sm capitalize">{order.status}</span>
              </div>
              <ul className="mt-2">
                {order.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="mt-2 flex gap-2">
                {order.status !== 'ready' && (
                  <button className="text-sm bg-green-500 text-white px-2 py-1 rounded">
                    Mark Ready
                  </button>
                )}
                <button className="text-sm bg-red-500 text-white px-2 py-1 rounded">
                  Cancel
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PosDashboard;
